import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { NOTES_QUERY_KEY } from "./useNotes";

type UpdateNoteBody = components["schemas"]["UpdateNoteBody"];
type NoteResponse = components["schemas"]["NoteResponse"];

export type UpdateNoteVariables = {
  noteId: string;
  body: UpdateNoteBody;
};

export function useUpdateNote() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<NoteResponse, Error, UpdateNoteVariables>({
    mutationFn: async ({ noteId, body }) => {
      const { data, error } = await client.PATCH("/api/notes/{note_id}", {
        params: { path: { note_id: noteId } },
        body,
      });
      if (error !== undefined) {
        throw new Error(`Failed to update note ${noteId}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: NOTES_QUERY_KEY });
    },
  });
}
